<template>
  <v-container grid-list-md text-xs-center v-if="hasTableData">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-container class="pa-1" fluid grid-list-lg>
            <v-flex xs12>
              <v-card color="green lighten-1" class="white--text">
                <v-card-title primary-title>
                  <v-flex>
                    <div class="headline">
                      <v-avatar color="black" :size="'70px'">
                        <img
                          v-if="currentUser.images[0]"
                          :src="currentUser.images[0].url"
                          alt="John"
                        />
                        <span
                          v-if="!currentUser.images[0]"
                          class="white--text headline"
                          >{{ currentUser.display_name.charAt(0) }}</span
                        >
                      </v-avatar>
                    </div>
                    <div>{{ currentUser.display_name }}</div>
                    <div>({{ currentUser.product }})</div>
                  </v-flex>
                </v-card-title>
                <v-card-actions>
                  <v-flex> <v-btn flat dark>Share</v-btn> </v-flex>
                </v-card-actions>
                <v-card-title> <h4>Features</h4> </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-tile
                    v-for="feat in Object.keys(topTracks.userFeatures)"
                    :key="feat.id"
                  >
                    <v-list-tile-content>{{ feat }}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ topTracks.userFeatures[feat] | roundFloat }}
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card class="pa-2">
          <v-data-table
            v-if="hasTableData"
            :headers="headers"
            :items="tracksAsTable"
            class="elevation-1"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">
                <span
                  v-for="(artist, index) in props.item.artists"
                  :key="artist.name"
                >
                  {{
                    index === props.item.artists.length - 1
                      ? artist.name
                      : artist.name + ", "
                  }}
                </span>
              </td>
              <td class="text-xs-right">{{ props.item.rank }}</td>
              <td class="text-xs-right">{{ props.item.acousticness }}</td>
              <td class="text-xs-right">{{ props.item.danceability }}</td>
              <td class="text-xs-right">{{ props.item.energy }}</td>
              <td class="text-xs-right">{{ props.item.instrumentalness }}</td>
              <td class="text-xs-right">{{ props.item.liveness }}</td>
              <td class="text-xs-right">{{ props.item.loudness }}</td>
              <td class="text-xs-right">{{ props.item.speechiness }}</td>
              <td class="text-xs-right">{{ props.item.valence }}</td>
              <td class="text-xs-right">{{ props.item.tempo }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { roundFloat } from "./../utils/numbers";
export default {
  data() {
    return {
      pagination: { rowsPerPage: 10 },
      bottom: false,
      headers: [
        {
          text: "Track",
          align: "left",
          sortable: false,
          value: "name"
          // width: "50%"
        },
        {
          text: "artist",
          align: "left",
          sortable: false,
          value: "artist"
        },
        {
          text: "Rank",
          align: "left",
          sortable: true,
          value: "rank"
        },
        {
          text: "acousticness",
          align: "left",
          sortable: true,
          value: "acousticness"
        },
        {
          text: "danceability",
          align: "left",
          sortable: true,
          value: "danceability"
        },
        {
          text: "energy",
          align: "left",
          sortable: true,
          value: "energy"
        },
        {
          text: "instrumentalness",
          align: "left",
          sortable: true,
          value: "instrumentalness"
        },
        {
          text: "liveness",
          align: "left",
          sortable: true,
          value: "liveness"
        },
        {
          text: "loudness",
          align: "left",
          sortable: true,
          value: "loudness"
        },
        {
          text: "speechiness",
          align: "left",
          sortable: true,
          value: "speechiness"
        },
        {
          text: "valence",
          align: "left",
          sortable: true,
          value: "valence"
        },
        {
          text: "tempo",
          align: "left",
          sortable: true,
          value: "tempo"
        }
      ]
    };
  },

  created: function() {
    this.$store.dispatch("getAllTopTracks");
  },
  methods: {},
  computed: {
    hasTableData() {
      return this.$store.getters.topTracks.hasTableData;
    },
    topTracks() {
      return this.$store.getters.topTracks;
    },
    tracksAsTable() {
      return this.$store.getters.tracksAsTable;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  filters: {
    roundFloat: function(val) {
      return roundFloat(val, 2);
    }
  }
};
</script>

<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
th {
  background-color: #66bb6a;
}
</style>
